import React, { useEffect } from "react";
import HeaderBar from "./common/HeaderBar";
import FooterBar from "./common/FooterBar";
import "../style/about.scss";

const Cookies = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <React.Fragment>
      <HeaderBar />
      <div className="mx-auto max-w-[70%] p-10 text-[12px] leading-[30px]">
        <div className="my-10 text-[20px]">Collection & Cookies</div>

        <p className="text-[14px] leading-10">
          Like many websites, we use Cookies on our Site. For specific
          information about the Cookies that we use related to powering our
          store with Shopify, see https://www.shopify.com/legal/cookies. We use
          Cookies to power and improve our Site and our Services (including to
          remember your actions and preferences), to run analytics and better
          understand user interaction with the Services (in our legitimate
          interests to administer, improve and optimize the Services). We may
          also permit third parties and services providers to use Cookies on our
          Site to better tailor the services, products and advertising on our
          Site and other websites.
          <br />
          Most browsers automatically accept Cookies by default, but you can
          choose to set your browser to remove or reject Cookies through your
          browser controls. Please keep in mind that removing or blocking
          Cookies can negatively impact your user experience and may cause some
          of the Services, including certain features and general functionality,
          to work incorrectly or no longer be available. Additionally, blocking
          Cookies may not completely prevent how we share information with third
          parties such as our advertising partners.
          <br />
          Our website also recognizes the Global Privacy Control (GPC) signal,
          which enables you to opt-out of certain uses or disclosures of your
          information. If you notify us of your preference through GPC, we will
          treat such signal as a valid request to opt out of sharing / targeted
          advertising for the associated browser or device, and, if we are able
          to associate the device sending the signal to a Shopify account, we
          will apply the opt out request to the account as well. To learn more
          about Global Privacy Control, you can visit
          https://globalprivacycontrol.org/. Other than the Global Privacy
          Control, we do not recognize other “Do Not Track” signals that may be
          sent from your web browser or device.
          <br />
          How We Disclose Personal Information
          <br />
          In certain circumstances, we may disclose your personal information to
          third parties for contract fulfillment purposes, legitimate purposes
          and other reasons subject to this Privacy Policy. Such circumstances
          may include:
          <br />
          With vendors or other third parties who perform services on our behalf
          (e.g., IT management, payment processing, data analytics, customer
          support, cloud storage, fulfillment and shipping). With business and
          marketing partners, including Shopify, to provide services and
          advertise to you. For example, we use Shopify to support personalized
          advertising with third-party services. Our business and marketing
          partners will use your information in accordance with their own
          privacy notices. When you direct, request us or otherwise consent to
          our disclosure of certain information to third parties, such as to
          ship you products or through your use of social media widgets or login
          integrations, with your consent. With our affiliates or otherwise
          within our corporate group, in our legitimate interests to run a
          successful business. In connection with a business transaction such as
          a merger or bankruptcy, to comply with any applicable legal
          obligations (including to respond to subpoenas, search warrants and
          similar requests), to enforce any applicable terms of service, and to
          protect or defend the Services, our rights, and the rights of our
          users or others. We have in the past 12 months disclosed the following
          categories of personal information and sensitive personal information
          about users for the purposes set out above in "How we Collect and Use
          your Personal Information" and "How we Disclose Personal Information":
          <br />
          Category Categories of Recipients
          <br />
          Identifiers such as basic contact details and certain order and
          account information Personal information categories listed in the
          California Customer Records statute such as basic contact details and
          certain order and account information Commercial information such as
          order information, shopping information and customer support
          information Internet or other similar network activity, such as Usage
          Data Geolocation data such as locations determined by an IP address or
          other technical measures Vendors and third parties who perform
          services on our behalf (such as Internet service providers, payment
          processors, fulfillment partners, customer support partners and data
          analytics providers) Business and marketing partners Affiliates
          <br />
          We do not use or disclose sensitive personal information without your
          consent or for the purposes of inferring characteristics about you.
          <br />
          We have “sold” and “shared” (as those terms are defined in applicable
          law) personal information over the preceding 12 months for the purpose
          of engaging in advertising and marketing activities, as follows.
          <br />
          Category of Personal Information Categories of Recipients Identifiers
          such as name, e-mail address and phone number Business and marketing
          partners Commercial information such as records of products or
          services purchased Business and marketing partners Usage Data Business
          and marketing partners User Generated Content
          <br />
          The Services may enable you to post product reviews and other
          user-generated content. If you choose to submit user generated content
          to any public area of the Services, this content will be public and
          accessible by anyone.
          <br />
          We do not control who will have access to the information that you
          choose to make available to others, and cannot ensure that parties who
          have access to such information will respect your privacy or keep it
          secure. We are not responsible for the privacy or security of any
          information that you make publicly available, or for the accuracy, use
          or misuse of any information that you disclose or receive from third
          parties.
          <br />
          Third Party Websites and Links
          <br />
          Our Site may provide links to websites or other online platforms
          operated by third parties. If you follow links to sites not affiliated
          or controlled by us, you should review their privacy and security
          policies and other terms and conditions. We do not guarantee and are
          not responsible for the privacy or security of such sites, including
          the accuracy, completeness, or reliability of information found on
          these sites. Information you provide on public or semi-public venues,
          including information you share on third-party social networking
          platforms may also be viewable by other users of the Services and/or
          users of those third-party platforms without limitation as to its use
          by us or by a third party. Our inclusion of such links does not, by
          itself, imply any endorsement of the content on such platforms or of
          their owners or operators, except as disclosed on the Services.
          <br />
          Children's Data
          <br />
          The Services are not intended to be used by children, and we do not
          knowingly collect any personal information about children. If you are
          the parent or guardian of a child who has provided us with their
          personal information, you may contact us using the contact details set
          out below to request that it be deleted.
          <br />
          As of the Effective Date of this Privacy Policy, we do not have actual
          knowledge that we “share” or “sell” (as those terms are defined in
          applicable law) personal information of individuals under 16 years of
          age.
          <br />
          Security and Retention of Your Information
          <br />
          Please be aware that no security measures are perfect or impenetrable,
          and we cannot guarantee “perfect security.” In addition, any
          information you send to us may not be secure while in transit. We
          recommend that you do not use insecure channels to communicate
          sensitive or confidential information to us.
          <br />
          How long we retain your personal information depends on different
          factors, such as whether we need the information to maintain your
          account, to provide the Services, comply with legal obligations,
          resolve disputes or enforce other applicable contracts and policies.
          <br />
          Your Rights
          <br />
          Depending on where you live, you may have some or all of the rights
          listed below in relation to your personal information. However, these
          rights are not absolute, may apply only in certain circumstances and,
          in certain cases, we may decline your request as permitted by law.
          <br />
          Right to Access / Know: You may have a right to request access to
          personal information that we hold about you, including details
          relating to the ways in which we use and share your information. Right
          to Delete: You may have a right to request that we delete personal
          information we maintain about you. Right to Correct: You may have a
          right to request that we correct inaccurate personal information we
          maintain about you. Right of Portability: You may have a right to
          receive a copy of the personal information we hold about you and to
          request that we transfer it to a third party, in certain circumstances
          and with certain exceptions. Restriction of Processing: You may have
          the right to ask us to stop or restrict our processing of personal
          information. Withdrawal of Consent: Where we rely on consent to
          process your personal information, you may have the right to withdraw
          this consent. Appeal: You may have a right to appeal our decision if
          we decline to process your request. You can do so by replying directly
          to our denial. Managing Communication Preferences: We may send you
          promotional emails, and you may opt out of receiving these at any time
          by using the unsubscribe option displayed in our emails to you. If you
          opt out, we may still send you non-promotional emails, such as those
          about your account or orders that you have made. You may exercise any
          of these rights where indicated on our Site or by contacting us using
          the contact details provided below.
          <br />
          We will not discriminate against you for exercising any of these
          rights. We may need to collect information from you to verify your
          identity, such as your email address or account information, before
          providing a substantive response to the request. In accordance with
          applicable laws, you may designate an authorized agent to make
          requests on your behalf to exercise your rights. Before accepting such
          a request from an agent, we will require that the agent provide proof
          you have authorized them to act on your behalf, and we may need you to
          verify your identity directly with us. We will respond to your request
          in a timely manner as required under applicable law.
          <br />
          We use Shopify's ad services such as Shopify Audiences to help
          personalize the advertising you see on third party websites. To opt
          out of personalized advertising with third-party services supported by
          Shopify, visit https://privacy.shopify.com/en.
        </p>
      </div>
      <FooterBar />
    </React.Fragment>
  );
};

export default Cookies;
